import { BlocksIconLocationFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/location-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconLocationFilled = createComponent({
  react: React,
  tagName: 'cat-icon-location-filled',
  elementClass: BlocksIconLocationFilled
});
